import React from "react";
import { Container, Col, Row, Image } from "react-bootstrap";
import { Breadcrumbs, Link, Typography } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import "../../../Assets/css/mjstatic.css";
import Button from "@mui/material/Button";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { client_name, ImageUrl, Je_welryspelling } from "../../../Helpers/request";
import JewelryRepairImg from "../../../Assets/nokaoi-imges/jewelry-repair-services.jpg";
import BannerImgRepiare from "../../../Assets/nokaoi-imges/j-repair-banner.png";

const JewelryRepairServices = () => {
    const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{metaDetails.title}</title>
                <meta name="description" content={metaDetails.description}></meta>
                <meta name="keywords" content={metaDetails.keywords}></meta>
                {/* <link rel="canonical" href="https://hemmingjewelers.com/our-story" /> */}
            </Helmet>
            <div className="rcs_ringsetting_section mt-0">

                <Container fluid>
                    <Row>
                        <Col sm={12} md={12} className="p-0">
                            <Image src={BannerImgRepiare} className="img-fluid w-100 m-auto" />
                        </Col>
                    </Row>
                </Container>
                <Container>
                    <Row>
                        <Col className="rcs_breadcrumb mt-3 mb-md-2">
                            <Breadcrumbs aria-label="breadcrumb">
                                <Link underline="hover" color="inherit" href="/">
                                    Home
                                </Link>
                                <Typography color="text.primary">Jewelry Repair Services</Typography>
                            </Breadcrumbs>
                        </Col>
                    </Row>
                </Container>
                <Container>
                    {/* <Row className="m-auto w-100">
                        <div className="rcs_story_content mt-4">
                            <h2>About Us</h2>
                            <h2>NO KA ‘OI Jewelers is where jewelry meets its best!</h2>
                            <p>“We make dreams come true one ring at a time”</p>
                            <p>NO KA ‘OI Jewelers is a family-owned store with decades of experience in the diamond industry. Our showroom is located on the beautiful island of Maui, Hawaii. Our name means the best in the Hawaiian language, and we strive hard to live up to it. We are experts in providing natural GIA-certified diamonds, lab-grown diamonds, custom jewelry design, and manufacturing, along with all types of diamond jewelry crafted to the highest standard. Our GIA-certified diamonds are technically drawn from the world's largest and most ethical diamond cutters, while our lab-created diamonds are curated with the finest technology to ensure the brilliance and durability of each diamond. We invite you to explore our site using filters to find exactly what you want. You can contact us by phone or email if you need further assistance. We pride ourselves on the individual attention we give to each customer.</p>
                        </div>
                    </Row> */}

                    <div className="rcs_story_content mt-4 mb-3">
                        <Row className="m-auto w-100">
                            <Col sm={12} md={12} className="mb-4">
                                <h2 className="text-center">Jewelry Repair Services</h2>
                                <p className="text-center">At NO KA ‘OI Jewelers, our highly skilled jewelers utilize the latest technology and tools in laser welding, Cad design software, 3D printing. Our jewelers have decades of experience in jewelry making and repair.</p>
                            </Col>
                            <Col md={6} xs={12} className="order-2 order-sm-2 order-md-1 order-lg-1">
                                <ul>
                                    <li>Highly experienced jewelers</li>
                                    <li>CAD design software to create latest designs</li>
                                    <li>3D printing</li>
                                    <li>Laser Welding Technology</li>
                                    <li>Ring sizing</li>
                                    <li>Prong re-tipping</li>
                                    <li>Full jewelry restoration and fabrication</li>
                                    <li>Stone setting</li>
                                    <li>Rhodium plating for white gold</li>
                                    <li>Chain repair and clasp replacement</li>
                                    <li>Hawaiian Jewelry resizing, re-engraving, re-enameling</li>
                                    <li>Jewelry polishing and cleaning</li>
                                    <li>Full custom design and production</li>
                                </ul>
                            </Col>
                            <Col md={6} xs={12} className="order-1 order-sm-1 order-md-1 order-lg-1">
                                <div className="rcs_our_story_img_main">
                                    <Image src={JewelryRepairImg} alt="Jewelry Repair Services" className="img-fluid w-100 mb-4 mb-md-0"></Image>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </div>
    );
};

export default JewelryRepairServices;
